import Swiper, {Thumbs} from "../../assets/.npm/node_modules/swiper";

export default () => {
    const thumbsP = new Swiper('.pro-thumbs', {
        spaceBetween: 15,
        slidesPerView: 1.5,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          640: { slidesPerView: 2 },
          992: { slidesPerView: 4 },
        },
    });

    const mainP = new Swiper('.pro-main', {
        modules: [Thumbs],
        spaceBetween: 15,
        thumbs: {
            swiper: thumbsP
        }
    });
};
  